// extracted by mini-css-extract-plugin
export default {"formAdd":"user_formAdd__YZmXG","formTitle":"user_formTitle__GNdVT","loginForm":"user_loginForm__wNljR","loginBack":"user_loginBack__TBI35"};